export default __webpack_public_path__ + "static/media/MH.0610a7d0.svg";